@for ( component of components(); track component.label) {
<mat-card cdklDragHandle>
    <mat-card-title-group>
        <mat-card-header>
            {{component.label}}
        </mat-card-header>
        <mat-card-subtitle>
            {{component.message}}
        </mat-card-subtitle>
    </mat-card-title-group>
    <mat-card-content>
        {{component.description}}
    </mat-card-content>
    <mat-card-footer>
        <mat-card-actions>
            @for ( action of actions(); track action.title; ) {
            <button mat-fab extended>
                <mat-icon>{{action.icon}}</mat-icon>{{action.title}}
            </button>
            }
        </mat-card-actions>
    </mat-card-footer>
</mat-card>
}